import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer id="site-footer" data-testid="footer" className="relative py-16 md:py-24 px-6 md:px-12 overflow-hidden">
      <div className="relative max-w-[1600px] mx-auto">
        <div className="pt-10 border-t border-line flex flex-col md:flex-row items-center md:items-start justify-between gap-6 md:gap-8 text-center md:text-left">
          <div className="flex items-center gap-3">
            <span className="w-2 h-2 rotate-45 bg-gold" />
            <span className="font-mono text-lg text-ink">elite-domains<span className="text-gold">.com</span></span>
          </div>
          <div className="flex flex-wrap justify-center md:justify-start gap-x-8 gap-y-3 font-mono text-[11px] uppercase tracking-[0.2em] text-ink-dim">
            <a href="/#collection" className="hover:text-ink transition-colors">Collection</a>
            <Link to="/about" data-testid="footer-about-link" className="hover:text-ink transition-colors">About</Link>
            <Link to="/faq" data-testid="footer-faq-link" className="hover:text-ink transition-colors">FAQ</Link>
            <Link to="/contact" data-testid="footer-contact-link" className="hover:text-ink transition-colors">Contact</Link>
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink-dim/60">
            © 2026 elite-domains.com · Confidential
          </div>
        </div>
      </div>
    </footer>
  );
}
